import Promise from 'promise';
import Vue from 'vue';
import utils from './utils';

if (typeof Promsie !== 'function') {
  window.Promise = Promise;
}

(function () {
  /* eslint-disable no-extend-native */
  Date.prototype.format = function (fmt) {
    const o = {
      'M+': this.getMonth() + 1,
      'd+': this.getDate(),
      'h+': this.getHours(),
      'm+': this.getMinutes(),
      's+': this.getSeconds(),
      'q+': Math.floor((this.getMonth() + 3) / 3),
      S: this.getMilliseconds(),
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (`${this.getFullYear()}`).substr(4 - RegExp.$1.length));
    /* eslint-disable no-restricted-syntax */
    for (const k in o) { if (new RegExp(`(${k})`).test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length))); }
    return fmt;
  };

  if (!Date.now) { Date.now = function () { return new Date().getTime(); }; }
}());

Vue.prototype.formatDate = function (dateString, format) {
  if (!dateString) {
    return '';
  }

  format = format || 'yyyy年MM月dd日';
  const date = new Date(dateString);

  return date.format(format);
};

Vue.prototype.$statsTrigger = utils.statsTrigger;

Vue.prototype.$backgroundImage = function (url, defaultUrl) {
  const link = url || defaultUrl;

  return {
    backgroundImage: link ? `url(${link})` : undefined,
  };
};

Vue.prototype.$importImage = utils.importImage;

Vue.prototype.$showPrice = (price) => {
  if (!price) {
    return 0;
  }

  return parseInt(price / 10, 10) / 10;
};

(function () {
  const vendors = ['webkit', 'moz'];
  for (let i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
    const vp = vendors[i];
    window.requestAnimationFrame = window[`${vp}RequestAnimationFrame`];
    window.cancelAnimationFrame = (window[`${vp}CancelAnimationFrame`]
      || window[`${vp}CancelRequestAnimationFrame`]);
  }
  if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) // iOS6 is buggy
      || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
    let lastTime = 0;
    window.requestAnimationFrame = function (callback) {
      const now = Date.now();
      const nextTime = Math.max(lastTime + 16, now);
      return setTimeout(() => { callback(lastTime = nextTime); },
        nextTime - now);
    };
    window.cancelAnimationFrame = clearTimeout;
  }
}());



// WEBPACK FOOTER //
// ./src/libs/add-prototype-methods.js